module.exports = __webpack_public_path__ + "img/bg1.341b9855.png";